import 'css-chunksrc/client/scenes/projectElementDetailsConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_95otu_1",
  "columnWrapper": "_columnWrapper_95otu_7",
  "column": "_column_95otu_1",
  "iconBox": "_iconBox_95otu_27",
  "icon": "_icon_95otu_27",
  "columnIcon": "_columnIcon_95otu_45",
  "hidden": "_hidden_95otu_54"
};